import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import logoV2 from '../assets/Logov2.png';

export function Home() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/onboarding');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50 dark:from-emerald-900 dark:via-green-900 dark:to-teal-900">
      <div className="max-w-4xl w-full px-6 relative">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-emerald-400/10 rounded-full filter blur-3xl -z-10" />
        <div className="absolute bottom-0 right-0 w-72 h-72 bg-teal-400/10 rounded-full filter blur-3xl -z-10" />
        
        <div className="text-center space-y-12 relative">
          <div className="space-y-6">
            <h1 className="text-6xl font-bold tracking-tight bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent dark:from-emerald-400 dark:to-teal-400 animate-fade-in">
              LeaseCheck
            </h1>
            <p className="text-2xl font-semibold text-emerald-600 dark:text-emerald-400 animate-fade-in">
              Verify Legal Compliance Easily
            </p>
          </div>

          <div className="flex justify-center">
            <img
              src={logoV2}
              alt="LeaseCheck Logo"
              className="h-48 w-auto animate-fade-in drop-shadow-xl"
            />
          </div>

          <p className="text-xl text-slate-700 dark:text-slate-300 animate-fade-in">
            Your Intelligent Lease Analysis Solution
          </p>

          <div className="space-y-8">
            <p className="text-lg text-slate-600 dark:text-slate-400 max-w-2xl mx-auto animate-slide-in">
              Experience Deep Lease Intelligence™ in action. Our AI-powered system performs comprehensive analysis of your lease documents, providing clear, actionable insights instantly.
            </p>

            <Button
              onClick={handleGetStarted}
              className="text-lg px-12 py-4 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white shadow-lg hover:shadow-xl transform transition hover:-translate-y-0.5 animate-slide-in rounded-xl"
            >
              Start Your Review
            </Button>

            <p className="text-xs text-slate-500 dark:text-slate-400">
              LeaseCheck screens Colorado residential leases for common legal and
              financial risks. It is not legal advice.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
